<script setup>
import { computed } from 'vue'
import { useProfileStore } from '@/stores/profile'
import UTACars from '@/components/UTACars.vue'
import UTACarsGroups from '@/components/groupsCars/UTACarsGroups.vue'

const profileStore = useProfileStore()
const profile = computed(() => profileStore.profile)

</script>

<template>
    <div class="page page--cars">
        <UTACars />
        <UTACarsGroups v-if="profile.attr?.array.includes('SUPER_ADMIN')" />
    </div>
</template>
